<template>
  <div class="tender-commercial-offer">
    <slot name="title"/>
    <CollapseBlock
      class="tender-commercial-offer_document"
      transparent
      :value.sync="show.documents">
      <div
        v-if="!isWithoutPublication"
        slot="title"
        class="tender-commercial-offer_document-title">
        {{ $t('Common.LoadDocument') }}
        <sIcon
          class="ml-2 my-auto"
          :rotate="show.documents ? '-180' : '0'"
          size="10"
          type="arrow"/>
      </div>
      <div
        v-if="loading.documents"
        key="spinner"
        class="my-auto mx-auto pb-5">
        <sIcon
          color="#ced8d7"
          size="40"
          spin
          type="loading"/>
      </div>
      <ImportBlock
        v-else
        :add-files="addFiles"
        class="tender-commercial-offer_document-content"
        :create-file-handler="createFileHandler"
        :files.sync="files"
        files-types
        inline-style="width: 464px"/>
    </CollapseBlock>
    <template v-if="!isWithoutPublication">
      <div class="tender-commercial-offer_title">
        {{ $t('Tenders.RequestForCommercialOffer') }}
      </div>
      <div class="tender-commercial-offer_description">
        {{ $t('Tenders.CommercialOfferText') }}
      </div>
      <div class="tender-commercial-offer_radio-title">
        {{ $t('Tenders.WhatLanguageSendInvitations') }} ?
      </div>
      <sRadioGroup
        class="tender-commercial-offer_radio"
        data-qa="check-lang"
        :disabled="loading.offer"
        row
        :value="lang">
        <sRadio
          v-for="langItem in langs"
          :key="langItem.value"
          data-qa="check-lang-uk"
          :label="langItem.key"
          @change="setOfferLanguage(langItem.key)">
          {{ langItem.label }}
        </sRadio>
      </sRadioGroup>

      <CollapseBlock
        class="tender-commercial-offer_offer"
        transparent
        :value.sync="show.offer"
        @update:value="getOfferDocument">
        <div
          slot="title"
          class="tender-commercial-offer_offer-title">
          <span>{{ $t('Tenders.RequestForCommercialOffer') }}</span>
          <AddCOAdditionalConditions
            ref="additionalConditions"
            :disabled="loading.offer || !offerFile"
            small
            @updateOffer="setCommercialOffer"/>
          <sButton
            class="btn"
            :disabled="loading.offer || !offerFile"
            small
            type="text"
            @click.stop="offer.saveFile()">
            <sIcon
              class="mr-3"
              type="download"/>
            {{ $t('Tenders.Download') }}
          </sButton>
          <sButton
            class="btn"
            :disabled="loading.offer || !offerFile"
            small
            type="text"
            @click.stop="printDocument">
            <sIcon
              class="mr-3"
              type="printer"/>
            {{ $t('Tenders.Print') }}
          </sButton>
          <sIcon
            class="ml-2 my-auto"
            :rotate="show.offer ? '-180' : '0'"
            size="10"
            type="arrow"/>
        </div>
        <div
          class="tender-commercial-offer_document-offer width-100 main__light_green py-6 px-10 text-center">
          <sAlert
            v-if="offerError"
            type="error">
            {{ $t('Tenders.ErrorLoadingCommercialOffer') }}
            <div slot="desc">
              <sButton
                small
                type="text"
                @click="getOfferDocument">
                {{ $t('Common.RepeatLoading') }}
              </sButton>
            </div>
          </sAlert>
          <sIcon
            v-else-if="loading.offer || !offerFile"
            class="my-5 mx-auto"
            color="var(--secondary__green_not_active)"
            size="30"
            spin
            type="loading"/>
          <DocumentView
            v-else-if="offerFile"
            class="commercial-offer-document"
            :file.sync="offer"/>
        </div>
      </CollapseBlock>
    </template>
  </div>
</template>
<script>
import CollapseBlock from 'components/common/CollapseBlock.vue'
import ImportBlock from 'components/common/blocks/ImportBlock.vue'
import DocumentView from 'components/common/elements/DocumentView.vue'
import AddCOAdditionalConditions from 'components/tenders/dialogs/AddCOAdditionalConditions.vue'

import { TenderFile } from '@/types/commonFile.js'
import { commercialOfferFile } from '@/types/commonFile.js'
import AiApi from '@/api/aiApi'
const aiApi = new AiApi()

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'TenderCommercialDocumentAndOffer',
  data() {
    return {
      files: [],
      loading: {
        documents: true,
        offer: true,
      },
      lang: null,
      show: {
        documents: true,
        offer: false,
      },
      offerError: false,
      offer_translations: {},
      langs: [
        {
          key: 'uk',
          value: 'UKRAINIAN',
          label: this.$t('Common.Ukrainian')
        },{
          key: 'en',
          value: 'ENGLISH',
          label: this.$t('Common.English')
        }
      ],
      //old: []
    }
  },
  methods: {
    afterSendTender() {
      const isFiles = this.files?.length > 0 || this.$refs.additionalConditions?.files?.length > 0
      if (this.growthBook.ai_functionals && this.$can('use', 'aiRequirementsFromDocument') && isFiles) {
        aiApi.fillRequirements(this.tender.tenderId)
      }
    },
    async printDocument() {
      let  reader = new FileReader()
      await reader.readAsText(this.offer?.file )
      let newChild
      reader.onload = (res) => {
        newChild = res.target.result
        document.getElementById('app').classList.add('hidden-print')
        let div = document.createElement('div')
        div.id = 'print-item'
        div.innerHTML = newChild.trim()
        document.body.appendChild(div)

        setTimeout(() => {
          window.print()

          document.getElementById('app').classList.remove('hidden-print')
          document.body.removeChild(div)
        }, 100)
      }
    },
    getOfferDocument() {
      this.offerError = false
      if (!this.show.offer || !this.offer || this.offerFile) {
        return
      }

      this.loading.offer = true
      this.offer.downloadFile()
        .catch(() => {
          this.offerError = true
          this.loading.offer = false
        })
        .finally(() => {
          this.loading.offer = false
        })
    },
    async setOfferLanguage(lang) {
      if (this.lang === lang) {
        return
      }
      this.loading.offer = true
      const item = this.langs.find(i => i.key === lang)
      localStorage.setItem(`kp_${this.$route?.query?.id}`, lang)
      await api.changeOfferLanguage(Number(this.$route?.query?.id), item?.value)
        .then((result) => {
          if (result) {
            this.lang = lang
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            this.getOfferDocument()
            this.loading.offer = false
          })
        })
    },
    setCommercialOffer() {
      this.loading.offer = true
      this.langs.forEach(lang => {
        this.$set(
          this.offer_translations,
          lang.key,
          new commercialOfferFile(this.tender.tenderId , `${this.$t('Tenders.CommercialOffer', [lang.key])}_${this.tender.tenderNumber}.html`)
        )
      })
      this.getOfferDocument()
      this.loading.offer = false
    },
    async uploadFiles(files) {
      let promises = files.filter(file => !file.id).map(async (file,) => {
        return await file.uploadFile()
          .catch(er => {
            this.files = this.files.slice(0)
            file.catchUploading(er)
          })
      })
      await Promise.allSettled(promises)
    },
    addFiles(files) {
      this.$emit('blockSteps', true)
      this.uploadFiles(files).finally(() =>  this.$emit('blockSteps', false))
    },
    createFileHandler(file) {
      return new TenderFile(this.tender.tenderId, null, null, file)
    }
  },
  computed: {
    isWithoutPublication() {
      return this.tender.biddingType.withoutPublication
    },
    offer() {
      return this.offer_translations[this.lang]
    },
    offerFile() {
      return this.offer?.file
    }
  },
  components: {
    ImportBlock,
    DocumentView,
    CollapseBlock,
    AddCOAdditionalConditions
  },
  created() {
    if (!this.tender.tenderId) {
      return
    }
    this.loading.documents = true
    this.$store.dispatch('getTenderItem', {id: this.tender.tenderId, condition: true })
      .then((res) => {
        if (res && res.attachments.length) {
          res.attachments.forEach(file => {
            let createdFile = new TenderFile(this.tender.tenderId, file.id, file.key, null, file.title, file?.size)
            this.files.push(createdFile)
          })
        }
      })
      .finally(() => {
        this.loading.documents = false
      })
    //this.old = this.files.slice(0)

    this.loading.offer = true
    this.setCommercialOffer()
    const localValue = localStorage.getItem(`kp_${this.$route?.query?.id}`)
    let defaultLang = this.$i18n.locale
    const lang = localValue && this.langs.map(i => i.key).includes(localValue) ? localValue : defaultLang
    this.$nextTick(() => {
      this.setOfferLanguage(lang)
    })
  },
  props: {
    tender: {
      type: Object
    },
    rules: {
      type: Object
    }
  },
}
</script>
<style scoped lang="scss">
.tender-commercial-offer {
  &_title {
    text-align: left;
    margin-top: 32px;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.18px;
  }
  &_description {
    text-align: left;
    margin-top: 16px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.32px;
  }
  &_radio {
    text-align: left;
    margin: 16px auto 0 0;
    display: block;
    &-title {
      text-align: left;
      margin-top: 16px;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.16px;
    }
  }
  &_document {
    margin-top: 16px;
    padding: 24px 24px 0 24px;
    border-radius: 5px !important;
    background-color: var(--v-main__light_green-base) !important;
    border-color: var(--v-main__light_green-base) !important;
    &-title {
      text-align: left;
      padding: 0 0 24px 0;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: -0.32px;
      display: grid;
      grid-template-columns: auto 20px;
      gap: 5px;
    }
    &-content {
      padding: 0 0 24px 0 !important;
    }
  }
  &_offer {
    margin-top: 16px;
    padding: 24px 24px 0 24px;
    border-radius: 5px !important;
    background-color: var(--v-main__light_green-base) !important;
    border-color: var(--v-main__light_green-base) !important;
    &-title {
      text-align: left;
      padding: 0 0 24px 0;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: -0.32px;
      display: grid;
      grid-template-columns: auto 204px 170px 170px 20px;
      gap: 12px;
    }
    &-content {
      padding: 0 0 24px 0 !important;
    }
  }
}
</style>
